import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const SalaryExplorePageNoDataHolder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  margin-bottom: 35px;
  text-align: center;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    justify-content: center;
  }
`;
